<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import {menuItems_0} from "../../../components/menu.js"
import { driver } from "driver.js"
import "driver.js/dist/driver.css"
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Editar Usuário",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect },
  setup() {

  },
  data() {
    return {
      empresaData: {},
      dtListPesqCidade: null,
      userPcts: null,

      showModalToken: false,
      pagamentoData: {},
      showModalPagamento: false,
      showModalUpgradePlano: false,
      planosData: [
          {
            id: 'tms_free',
            nome: 'TMS Free',
            text: 'Grátis / Limitado',
            icon: 'bx-walk',
            valor: 0.00,
            itens: ['1 usuário', 'Até 1 tabela de frete', 'Até 100 cotações mês', 'Até 20 contratações mês', 'Suporte E-mail']
          },
          {
            id: 'tms_plus',
            nome: 'TMS Plus',
            text: '',
            icon: 'bx-run',
            valor: 499.00,
            itens: ['5 usuários', 'Até 5 tabelas de frete', 'Rastreamento básico', 'Até 2.000 cotações mês', 'Até 500 contratações mês', 'Suporte Online']
          },
          {
            id: 'tms_enterprise',
            nome: 'TMS Enterprise',
            text: '',
            icon: 'bx-cycling',
            valor: 1499,
            itens: ['10 usuários', 'Até 10 tabelas de frete', 'Rastreamento avançado com e-mail', 'Cotações ilimitadas', 'Contratações ilimitadas', 'Suporte Online']
          },
          {
            id: 'tms_pro',
            nome: 'TMS Pro',
            text: 'Entre em contato',
            icon: 'bx-car',
            valor: 'Sob Consulta',
            itens: ['Usuários ilimitados', 'Até 15 tabelas (negociação pelo time econoPRO)', 'Rastreamento avançado com e-mail e Whatsapp', 'Cotações ilimitadas', 'Contratações ilimitadas', 'Suporte humanizado (profissional dedicado)']
          },
          {
            id: 'retomada',
            nome: 'TMS Pro',
            text: 'Entre em contato',
            icon: 'bx-car',
            valor: 'Sob Consulta',
            itens: ['Usuários ilimitados', 'Até 15 tabelas (negociação pelo time econoPRO)', 'Rastreamento avançado com e-mail e Whatsapp', 'Cotações ilimitadas', 'Contratações ilimitadas', 'Suporte humanizado (profissional dedicado)']
          }
      ],

      planoAtualData: {},
      showFormUserMenu: false,
      userMenusData: {},
      menuItens: null,

      emprTokensData: {},
      emprTokenData: {},
      showFormToken: false,
      pedidosData: null,
      errosValid: null,
      usuarioData: {},
      idData: 0,
      updating: true,
      submitted: false,
      submittedToken: false,
      title: "Editar Usuário",
      items: [
        {
          text: "Usuários",
          href: "/usuarios/list",
        },
        {
          text: "Editar Usuário",
          active: true,
        },
      ],

    };
  },

  methods: {

    falarConsultor(){
      console.log('falarConsultor')
      window.open('https://web.whatsapp.com/', '_blank')
    },


    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#empresacnpj', popover: { title: 'Dados de sua Empresa', description: 'Você precisa inserir seu CNPJ e clicar no botão Consultar CNPJ para preencher todos os dados da sua empresa, ou preencher manualmente.' } },
          { element: '#btnsalvaralt', popover: { title: 'Salvar', description: 'Em seguida salvar as alterações inseridas.' } },
          { element: '#btnnovotoken', popover: { title: 'Cadastrar Token', description: 'Último passo é cadastrar o token que será utilizado para suas cotações ou acessar Administrativo -> Base Cotação de Fretes para cadastro de suas tabelas.' } },
        ]
      })
      driverObj.drive()
    },


    deletarToken(idData){
      console.log('deletarToken')
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/emprtoken`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },


    novoTokenCot(){
      console.log('novoTokenCot')
      if (this.empresaData && this.empresaData.id) {
        this.showFormToken = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher e salvar os dados da empresa antes de cadastrar qualquer token.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    consultarCEP(){
      console.log('consultarCEP')
      const cepTratado = this.empresaData.cep.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length !== 8){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CEP deve possuir no mínimo 8 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cepTratado)
        console.log(cepTratado.length)
        this.updating = true

        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.empresaData.rua = res.data[0].logradouro
          this.empresaData.compl  = res.data[0].complemento
          this.empresaData.bairro = res.data[0].bairro
          this.empresaData.cidade = res.data[0].localidade
          this.empresaData.estado = res.data[0].uf
          this.empresaData.codmun = res.data[1].codigo

          this.dtListPesqCidade = [
            {
              'codigo': res.data[1].codigo,
              'descricao': res.data[1].descricao
            },
          ]

          this.updating = false
        });
      }


    },


    consultarCNPJ(){
      console.log('consultarCNPJ')
      const cnpjTratado = this.empresaData.cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.updating = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.empresaData.fantasia = res.data[0].fantasia
          this.empresaData.nome = res.data[0].nome
          this.empresaData.cnpj = res.data[0].cnpj
          this.empresaData.cep = res.data[0].cep
          this.empresaData.rua = res.data[0].logradouro
          this.empresaData.numero = res.data[0].numero
          this.empresaData.compl = res.data[0].compl
          this.empresaData.bairro = res.data[0].bairro
          this.empresaData.cidade = res.data[0].municipio
          this.empresaData.estado = res.data[0].uf
          this.empresaData.email = res.data[0].email
          this.empresaData.tel1 = res.data[0].telefone
          this.empresaData.codmun = res.data[1].codigo

          this.dtListPesqCidade = [
            {
              'codigo': res.data[1].codigo,
              'descricao': res.data[1].descricao
            },
          ]


          this.updating = false
        });
      }
    },


    escolheuCidade(){
      console.log('escolheuCidade')
      // console.log(this.empresaData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.empresaData.codmun }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData.cidade = res.data.descricao
        this.empresaData.estado = res.data.estado

      })
    },

    pesqCidade(evt){
      console.log('pesqCidade')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade = res.data
        });
      }
    },


    exibirToken(){
      console.log('exibirToken')
      this.showModalToken = true
    },


    confPagamento(){
      console.log('confPagamento')
      this.submitted = true
      this.showModalPagamento = false
      this.updating = true
      api.post(`${getBaseUrl()}api/cplplan`, {
        pagamentoData: this.pagamentoData
      }).then((response) => {
        console.log('then confPagamento')
        console.log(response.data)
        this.userPcts = response.data[0]
        this.usuarioData = response.data[1]
        this.planoAtualData = this.planosData.find(plano => plano.id === this.usuarioData.tipo);
        this.usuarioData.vencimento = moment(this.usuarioData.created_at).add(30, 'days').format('YYYY-MM-DD')
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Obrigado, o seu plano foi atualizado com sucesso, já pode fazer uso dos seus novos limites!",
          showConfirmButton: false,
          timer: 3500
        })
      })
    },


    escolheuPlano(plano){
      console.log('escolheuPlano')
      console.log(plano)
      this.showModalUpgradePlano = false
      this.pagamentoData = plano
      this.showModalPagamento = true
    },



    upgradePlano(){
      console.log('upgradePlano')
      this.showModalUpgradePlano = true
    },

 

    delUserMenu(idData){
      console.log('delUserMenu')

      console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/usumenu`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })


        }
      })


    },

    delUserEmpresa(idData){
      console.log('delUserempresa')

      console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/usuempresa`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })


        }
      })


    },


    editarToken(data){
      this.emprTokenData = data
      this.showFormToken = true

    },


    confToken() {
      console.log('confToken')
      this.emprTokenData.empresa_id = this.empresaData.id
      this.submittedToken = true

      if (this.emprTokenData.hub) {
        this.updating = true
        this.showFormToken = false
        api.post(`${getBaseUrl()}api/emprtoken`, {
          empreTokemData: this.emprTokenData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },


    carregarDados(){
      this.updating = true
      console.log(`idData: ${this.idData}`)
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/usuarioperf`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios user')
          console.log(res.data)
          // console.log('menuItens_0')
          // console.log(menuItems_0)
          let todosMenus = []
          menuItems_0.forEach((menuItem) => {
            // console.log(menuItem.id)
            // console.log(menuItem.subItems)
            todosMenus.push({
              id: menuItem.id,
              value: menuItem.label
            })
            if (menuItem.subItems) {
              menuItem.subItems.forEach((subItem) => {
                todosMenus.push({
                  id: subItem.id,
                  value: subItem.label
                })
              })
            }
          })
          this.menuItens = todosMenus
          //console.log('todosMenus')
          //console.log(todosMenus)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`)
          }else{
            this.usuarioData = res.data[0]
            this.pedidosData = res.data[1]
            this.emprTokensData = res.data[2]
            this.userMenusData = res.data[3]

            if (res.data[4]) {
              this.empresaData = res.data[4]
              this.dtListPesqCidade = [
                {
                  'codigo': this.empresaData.codmun,
                  'descricao': this.empresaData.cidade
                },
              ]
            }


            if (res.data[5]){
              this.userPcts = res.data[5]
            }

            let totalFat = 0
            let totalComiss = 0
            if (this.pedidosData) {
              this.pedidosData.forEach((value) => {
                totalFat = totalFat + value.valorliq
                totalComiss = totalComiss + parseFloat(value.valorcomissao)
              })
              this.totalFaturado = totalFat
              this.totalComissao = totalComiss
            }

            this.planoAtualData = this.planosData.find(plano => plano.id === this.usuarioData.tipo);
            this.usuarioData.vencimento = moment(this.usuarioData.created_at).add(30, 'days').format('YYYY-MM-DD')

            console.log('this.planoAtualData')
            console.log(this.planoAtualData)

            this.idData = this.usuarioData.id
            this.title = `Editar Usuário (${this.usuarioData.id}) ${this.usuarioData.name}`
            this.updating = false
          }
        })
      }else{
        this.title = `Criando Novo Usuário`
        this.updating = false
      }
    },

    formSubmit(){
      console.log('formSubmit')
      console.log(this.empresaData.cnpj)
      console.log(this.empresaData.cnpj.length)
      this.submitted = true;

      let validPass = false
      const contSpecial = /[`!@#$%^&*()_+\-=\\|,.<>?~]/.test(this.usuarioData.password)
      const contLetters = /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/.test(this.usuarioData.password)
      const contNumbers = /[0-9]/.test(this.usuarioData.password)

      if (this.usuarioData.password && this.usuarioData.password.length >= 8 && contSpecial && contLetters && contNumbers){
        validPass = true
      }

      if (this.usuarioData.password && !validPass){
        Swal.fire({
          text: "Favor preencher o campo senha com o mínimo de 8 caracteres, contento letras e números",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 2500
        })
      } else if (this.empresaData.cnpj && this.empresaData.cnpj.length !== 18){
        Swal.fire({
          text: "Tamanho do CNPJ deve ser de 14 dígitos, favor corrigir.",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 2500
        })
      } else {

        if (this.usuarioData.name) {
          this.updating = true
          this.errosValid = []
          api.post(`${getBaseUrl()}api/usuarioperf`, {
            usuarioData: this.usuarioData,
            empresaData: this.empresaData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.usuarioData = res.data[0]

            if (res.data[1]) {
              this.empresaData = res.data[1]
            }
            this.updating = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    this.carregarDados()
  }


};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button id="btnsalvaralt" variant="outline-primary" class="mx-2" @click="formSubmit"  >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

<!--              <b-button variant="outline-warning" class="mx-2" @click="exibirToken"  >
                <i class="bx bxs-shield font-size-16 align-middle me-2"></i>
                Token para API
              </b-button>-->

<!--              <b-button id="btnnovotoken" variant="outline-success" class="mx-2" @click="novoTokenCot"  >
                <i class="bx bxs-plus-circle font-size-16 align-middle me-2"></i>
                Novo Token Cotação
              </b-button>-->

              <b-button variant="info" class="mx-2" @click="ajuda">
                <i class="bx bx-help-circle font-size-16 align-middle me-2"></i>
                Ajuda
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="upgradePlano">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Upgrade Plano
              </b-button>

            </div>
          </div>
        </div>
      </div>



      <b-card-text>
        <div class="card">
          <div class="card-body">

            <form class="needs-validation" @submit.prevent="formSubmit">


              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="usernome">Nome de Usuário</label>
                    <input
                        id="usernome"
                        v-model="usuarioData.name"
                        type="text"
                        class="form-control"
                        placeholder="Nome"
                        :class="{'is-invalid': submitted && !usuarioData.name,}"/>
                    <div v-if="submitted && !usuarioData.name"
                         class="invalid-feedback">
                      <span v-if="submitted && !usuarioData.name">
                        Campo nome obrigatório, favor preencher
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <label for="useremail">Email</label>
                  <div class="position-relative">
                    <input
                        id="useremail"
                        type="text"
                        :maxlength="100"
                        v-model="usuarioData.email"
                        class="form-control"
                        placeholder="E-mail"
                        :disabled="true"/>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-3">
                    <label for="usertipo">Plano</label>
                    <select
                        id="usertipo"
                        v-model="usuarioData.tipo"
                        class="form-control"
                        :disabled="true">
                      <option value="admin">Administrador</option>
                      <option value="cotacao">Cotação</option>
                      <option value="coletor">Coletor</option>
                      <option value="gerent">Gerente</option>
                      <option value="logist">Logística</option>
                      <option value="repres">Representante</option>
                      <option value="superv">Supervisor</option>
                      <option value="tms_free">TMS Free</option>
                      <option value="pl_bsc_2">Plano Básico 02</option>
                      <option value="pl_bsc_3">Plano Básico 03</option>
                      <option value="pl_std_1">Plano Standard 01</option>
                      <option value="pl_std_2">Plano Standard 02</option>
                      <option value="pl_std_3">Plano Standard 03</option>
                      <option value="pl_prm_1">Plano Premium 01</option>
                      <option value="pl_prm_2">Plano Premium 02</option>
                      <option value="pl_prm_3">Plano Premium 03</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <label for="usertel1">Telefone</label>
                  <div class="position-relative">
                    <input
                        id="usertel1"
                        type="text"
                        v-model="usuarioData.tel1"
                        class="form-control"
                        placeholder="Telefone"/>

                    <div class="chat-input-links" v-if="usuarioData.tel1">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Abrir Whatsapp">
                            <i class="mdi mdi-phone"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="password">Senha</label>
                    <input
                        id="password"
                        v-model="usuarioData.password"
                        type="password"
                        class="form-control"
                        :disabled="true"
                        :placeholder="idData === 0 ? 'Senha' : 'Senha, deixar em branco caso não queira alterar'"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3 align-items-end align-content-end float-end">
                    <label for="status">Status</label>
                    <div class="position-relative">
                      <b-form-checkbox switch size="lg" v-model="usuarioData.status" :disabled="true" >
                        {{ usuarioData.status ? 'Ativo' : 'Inativo' }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>

                <hr class="mt-1"/>

              </div>

              <div class="row mt-0">
                <h4 class="card-title mb-4" >Empresa</h4>

                <div class="col-md-2">

                  <label for="empresacnpj">CNPJ</label>
                  <input
                      id="empresacnpj"
                      v-maska="'##.###.###/####-##'"
                      v-model="empresaData.cnpj"
                      type="text"
                      class="form-control"
                      placeholder="CNPJ"/>

                  <div class="chat-input-links" v-if="empresaData.cnpj">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            @click="consultarCNPJ"
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Consultar CNPJ">
                          <i class="mdi mdi-cloud-search-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </div>

                </div>



                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="empresarazao">Razão Social</label>
                    <input
                        id="empresarazao"
                        v-model="empresaData.nome"
                        type="text"
                        class="form-control"
                        placeholder="Razão Social"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="empresacep">CEP</label>
                    <div class="position-relative">
                      <input
                          id="empresacep"
                          v-maska="'##.###-###'"
                          v-model="empresaData.cep"
                          type="text"
                          class="form-control"
                          placeholder="CEP"/>
                      <div class="chat-input-links" v-if="empresaData.cep">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                @click="consultarCEP"
                                href="javascript: void(0);"
                                v-b-tooltip.hover
                                placement="top"
                                title="Consultar CEP">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="empresarua">Endereço</label>
                    <div class="position-relative">
                      <input
                          id="empresarua"
                          v-model="empresaData.rua"
                          type="text"
                          class="form-control"
                          placeholder="Endereço"/>

                    </div>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-3">
                    <label for="empresanumero">Número</label>
                    <input
                        id="empresanumero"
                        v-model="empresaData.numero"
                        type="text"
                        class="form-control"
                        placeholder="Número"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="empresabairro">Bairro</label>
                    <input
                        id="empresabairro"
                        v-model="empresaData.bairro"
                        type="text"
                        class="form-control"
                        placeholder="Bairro"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="empresacompl">Complemento</label>
                    <input
                        id="empresacompl"
                        v-model="empresaData.compl"
                        type="text"
                        class="form-control"
                        placeholder="Complemento"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">

                    <span class="font-size-13">Cidade </span>
                    <multiselect id="empresacidade"
                                 @search-change="pesqCidade"
                                 @select="escolheuCidade"
                                 v-model="empresaData.codmun"
                                 placeholder="Selecionar cidade"
                                 :options="dtListPesqCidade"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="codigo"
                                 class="mt-2">
                      <template #option="slotProps">
                        <div style="min-width: 25%;">
                            <span class="text-info">
                              {{ slotProps.option.estado }}
                            </span>
                        </div>
                        <div style="min-width: 300px;">
                            <span class="mx-4" >
                              {{ slotProps.option.descricao }}
                            </span>
                        </div>
                      </template>
                    </multiselect>

                  </div>
                </div>


                <div class="col-sm-2">
                  <div class="mb-3">
                    <label for="empresaestado">Estado</label>
                    <select id="empresaestado" v-model="empresaData.estado" class="form-control">
                      <option value="AC">Acre</option>
                      <option value="AL">Alagoas</option>
                      <option value="AP">Amapá</option>
                      <option value="AM">Amazonas</option>
                      <option value="BA">Bahia</option>
                      <option value="CE">Ceará</option>
                      <option value="ES">Espírito Santo</option>
                      <option value="GO">Goiás</option>
                      <option value="MA">Maranhão</option>
                      <option value="MT">Mato Grosso</option>
                      <option value="MS">Mato Grosso do Sul</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="PA">Pará</option>
                      <option value="PB">Paraíba</option>
                      <option value="PR">Paraná</option>
                      <option value="PE">Pernambuco</option>
                      <option value="PI">Piauí</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="RN">Rio Grande do Norte</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="RO">Rondônia</option>
                      <option value="RR">Roraima</option>
                      <option value="SC">Santa Catarina</option>
                      <option value="SP">São Paulo</option>
                      <option value="SE">Sergipe</option>
                      <option value="TO">Tocantins</option>
                      <option value="DF">Distrito Federal</option>
                    </select>
                  </div>
                </div>


              </div>


<!--              <div class="row mt-2">
                <hr />
                <h4 class="card-title mb-4">Tokens</h4>

                <div class="table-responsive">
                  <table class="table align-middle table-nowrap table-hover">
                    <thead class="table-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">HUB</th>
                      <th scope="col">Login</th>
                      <th class="text-end" scope="col">Data</th>
                      <th class="text-end" scope="col">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in emprTokensData" :key="data.id">

                      <td>{{ data.id }}</td>
                      <td>{{ data.hub }}</td>
                      <td>{{ data.login }}</td>
                      <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                      <td class="text-end">
                        <div class="button-items">
                          <b-button variant="outline-warning" @click="editarToken(data)">
                            <i class="mdi mdi-pencil d-block font-size-16"></i>
                          </b-button>
                          <b-button variant="outline-danger" @click="deletarToken(data.id)">
                            <i class="mdi mdi-trash-can d-block font-size-16"></i>
                          </b-button>
                        </div>
                      </td>

                    </tr>
                    </tbody>
                  </table>
                </div>



              </div>-->


              <hr class="mt-5"/>

              <div class="row mt-3" v-if="planoAtualData">

                <h4 class="card-title mb-4">Plano Atual</h4>



                  <div class="col-xl-3 col-md-3">
                    <div class="card plan-box">
                      <div class="card-body p-4">
                        <div class="d-flex">
                          <div class="flex-grow-1">
                            <h5>{{planoAtualData.nome}}</h5>
                            <p class="text-muted">{{planoAtualData.text}}</p>
                          </div>
                          <div class="ms-3">
                            <i :class="`bx ${planoAtualData.icon} h1 text-primary`"></i>
                          </div>
                        </div>
                        <div class="py-4">
                          <h2>
                            <sup>
                              <small>R$ </small>
                            </sup>
                            {{planoAtualData.valor}}/
                            <span class="font-size-13">Mensal</span>
                          </h2>
                        </div>
                        <div class="text-center plan-btn">
                          <a
                              href="javascript: void(0);"
                              class="btn btn-primary btn-sm position-relative"
                              @click="upgradePlano"
                          >Upgrade de Plano</a>
                        </div>
                        <div class="mt-3"></div>
                        <div class="plan-features mt-0" v-for="(item, index) in planoAtualData.itens" :key="index">
                          <p>
                            <i class="bx bx-checkbox-square text-primary me-2"></i> {{ item }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div class="col-lg-9">
                    <h4>Vencimento: {{ formatDate(usuarioData.vencimento) }}</h4>
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="card">
                          <div class="card-body">
                            <i
                                class="bx bx-calendar-alt"
                                style="font-size: 30px; color: #ff531f"
                            ></i>
                            <h5 class="mt-2">Plano {{ planoAtualData.nome }}</h5>
                            <p class="text-muted">Aquisição em {{ formatDate(usuarioData.created_at) }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">

                      <div class="col-lg-3"
                           v-for="data in userPcts" :key="data.id">
                        <div class="card">
                          <div class="card-body">
                            <i class="bx bx-code"
                               style="font-size: 30px; color: #ff531f"></i>
                            <h5 class="mt-2">{{ data.descricao }}</h5>
                            <p class="text-muted">{{ data.consumo }} de {{ data.limite === 0 ? 'ilimitado' : data.limite }}</p>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>




              </div>

            </form>

          </div>
        </div>

      </b-card-text>

    </div>



    <b-modal  size="lg"
              title="Criar novo Token para Cotação" v-model="showFormToken" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="hub">Hub</label>
                    <select
                        id="hub"
                        v-model="emprTokenData.hub"
                        class="form-control"
                        :class="{'is-invalid': submittedToken && !emprTokenData.hub}">
                      <option value="AMAZON">Amazon</option>
                      <option value="ANYMARKET">Any Market</option>
                      <option value="B2WNOVA">B2W Nova Api</option>
                      <option value="BLING">Bling</option>
                      <option value="LEROYMER">Leroy Merlin</option>
                      <option value="LOJAMEC">Loja do Mecânico</option>
                      <option value="MAGALU">Magazine Luiza</option>
                      <option value="SKYHUB">SkyHub</option>
                      <option value="TRAYCORP">TrayCorp</option>
                      <option value="VTEX">Vtex</option>

                    </select>
                    <div v-if="submittedToken && !emprTokenData.hub" class="invalid-feedback">
                      <span>Campo hub obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="validade">Validade</label>
                    <input
                        id="validade"
                        v-model="emprTokenData.validade"
                        type="number"
                        class="form-control"
                        placeholder="Validade"
                        :class="{'is-invalid': submittedToken && !emprTokenData.validade}"/>
                    <div v-if="submittedToken && !emprTokenData.validade" class="invalid-feedback">
                      <span>Campo validade obrigatório, favor preencher.</span>
                    </div>

                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="login">Login</label>
                    <input
                        id="login"
                        v-model="emprTokenData.login"
                        type="text"
                        class="form-control"
                        placeholder="Login"/>

                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="senha">Senha</label>
                    <input
                        id="senha"
                        v-model="emprTokenData.senha"
                        type="text"
                        class="form-control"
                        placeholder="Senha"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="token">Token</label>
                    <input
                        id="token"
                        v-model="emprTokenData.token"
                        type="text"
                        class="form-control"
                        placeholder="Token"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="cliid">Client ID</label>
                    <input
                        id="cliid"
                        v-model="emprTokenData.cliid"
                        type="text"
                        class="form-control"
                        placeholder="Client ID"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="clisecret">Client Secret</label>
                    <input
                        id="clisecret"
                        v-model="emprTokenData.clisecret"
                        type="text"
                        class="form-control"
                        placeholder="Client Secret"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="actoken">Access Token</label>
                    <textarea
                        id="actoken"
                        v-model="emprTokenData.actoken"
                        type="text"
                        rows="2"
                        :disabled="true"
                        class="form-control"
                        placeholder="Access Token"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="rftoken">Refresh Token</label>
                    <textarea
                        id="rftoken"
                        v-model="emprTokenData.rftoken"
                        type="text"
                        rows="2"
                        :disabled="true"
                        class="form-control"
                        placeholder="Refresh Token"/>

                  </div>
                </div>

              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormToken = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confToken">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>

            </form>

          </div>
        </div>
      </div>
    </b-modal>



    <b-modal  size="xl"
              title="Escolha o plano de acordo com sua necessidade" v-model="showModalUpgradePlano" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <b-row>
              <div v-for="data in planosData" :key="data.valor" class="col-xl-3 col-md-6">
                <div class="card plan-box">
                  <div class="card-body p-4">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <h5>{{data.nome}}</h5>
                        <p class="text-muted">{{data.text}}</p>
                      </div>
                      <div class="ms-3">
                        <i :class="`bx ${data.icon} h1 text-primary`"></i>
                      </div>
                    </div>
                    <div class="py-4" v-if="data.nome === 'TMS Pro'">
                      <h2>

                        {{data.valor}}

                      </h2>
                    </div>
                    <div class="py-4" v-else>
                      <h2>
                        <sup>
                          <small>R$ </small>
                        </sup>
                        {{data.valor}}/
                        <span class="font-size-13">Mensal</span>
                      </h2>
                    </div>
                    <div class="text-center plan-btn" v-if="data.nome === 'TMS Pro'">
                      <b-button :disabled="planoAtualData && planoAtualData.nome === data.nome"  class="btn btn-success btn-sm position-relative" @click="falarConsultor()">
                        Falar com Consultor
                      </b-button>
                    </div>
                    <div class="text-center plan-btn" v-else>
                      <b-button :disabled="planoAtualData && planoAtualData.nome === data.nome"  class="btn btn-success btn-sm position-relative" @click="escolheuPlano(data)">
                        Assinar Agora
                      </b-button>
                    </div>
                    <div class="mt-3"></div>
                    <div class="plan-features mt-0" v-for="(item, index) in data.itens" :key="index">
                      <p>
                        <i class="bx bx-checkbox-square text-primary me-2"></i> {{ item }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal
        size="xl"
        v-model="showModalPagamento"
        :title="`Favor preencher as informações abaixo para aquisição do plano (${ pagamentoData.nome })`"
        hide-footer
        title-class="text-black font-18"
        body-class="p-3">
      <form @submit.prevent="confPagamento">

        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="card-title">Informações sobre o Usuário e a Empresa</h4>
              <div>

                <b-row class="mt-4">
                  <b-col lg="4">
                    <b-form-group
                        id="input-group-1"
                        label="CNPJ"
                        label-for="input-cnpj"
                        class="mb-0">
                      <b-form-input
                          id="input-cnpj"
                          v-model="pagamentoData.cnpj"
                          v-maska="'##.###.###/####-##'"
                          placeholder="CNPJ"
                          :class="{'is-invalid': submitted && !pagamentoData.cnpj}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.cnpj" class="invalid-feedback">
                        <span>CNPJ obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col lg="4">
                    <b-form-group
                        id="input-group-1"
                        label="Nome da Empresa"
                        label-for="input-nome-empresa"
                        class="mb-0">
                      <b-form-input
                          id="input-nome-empresa"
                          v-model="pagamentoData.nomeempresa"
                          placeholder="Nome da Empresa"
                          :class="{'is-invalid': submitted && !pagamentoData.nomeempresa}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.nomeempresa" class="invalid-feedback">
                        <span>Nome da Empresa obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                </b-row>

                <b-row class="mt-0">

                  <b-col lg="4">
                    <b-form-group
                        id="input-group-1"
                        label="Seu Nome"
                        label-for="input-nome-usuario"
                        class="mb-0">
                      <b-form-input
                          id="input-nome-usuario"
                          v-model="pagamentoData.nomeusuario"
                          placeholder="Seu Nome"
                          :class="{'is-invalid': submitted && !pagamentoData.nomeusuario}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.nomeusuario" class="invalid-feedback">
                        <span>Nome de Usuário obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col lg="4">
                    <b-form-group
                        id="input-group-1"
                        label="Endereço de E-mail"
                        label-for="input-email"
                        class="mb-0">
                      <b-form-input
                          id="input-email"
                          v-model="pagamentoData.email"
                          placeholder="Endereço de E-mail"
                          :class="{'is-invalid': submitted && !pagamentoData.email}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.email" class="invalid-feedback">
                        <span>E-mail obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col lg="4">
                    <b-form-group
                        id="input-group-1"
                        label="Telefone de Contato"
                        label-for="input-telefone"
                        class="mb-0">
                      <b-form-input
                          id="input-telefone"
                          v-model="pagamentoData.telefone"
                          placeholder="Telefone de Contato"
                          :class="{'is-invalid': submitted && !pagamentoData.telefone}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.telefone" class="invalid-feedback">
                        <span>Telefone de Contato obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                </b-row>


              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="card-title">Informações de Pagamento</h4>
              <div class="mt-4">
                <div class="form-check form-check-inline font-size-16">
                  <input
                      class="form-check-input"
                      type="radio"
                      name="paymentoptionsRadio"
                      id="paymentoptionsRadio1"
                      checked=""/>
                  <label
                      class="form-check-label font-size-13"
                      for="paymentoptionsRadio1"><i
                      class="fab fa-cc-mastercard me-1 font-size-20 align-top"></i>
                    Cartão de Crédito
                  </label>
                </div>
                <div class="form-check form-check-inline font-size-16">
                  <input
                      class="form-check-input"
                      :disabled="true"
                      type="radio"
                      name="paymentoptionsRadio"
                      id="paymentoptionsRadio2"/>
                  <label
                      class="form-check-label font-size-13"
                      for="paymentoptionsRadio2">
                    <i class="fab fa-cc-paypal me-1 font-size-20 align-top"></i>
                    Paypal
                  </label>
                </div>
                <div class="form-check form-check-inline font-size-16">
                  <input
                      class="form-check-input"
                      type="radio"
                      :disabled="true"
                      name="paymentoptionsRadio"
                      id="paymentoptionsRadio3"/>
                  <label
                      class="form-check-label font-size-13"
                      for="paymentoptionsRadio3">
                    <i class="far fa-money-bill-alt me-1 font-size-20 align-top"></i>
                    PIX</label>
                </div>
              </div>

              <h5 class="mt-5 mb-3 font-size-15">Para Cartão de Crédito</h5>
              <div class="p-4 border">

                <b-form-group
                    id="input-group-2"
                    label="Número do Cartão"
                    label-for="input-card"
                    class="mb-0">
                  <b-form-input
                      id="input-card"
                      v-model="pagamentoData.cartao"
                      v-maska="'#### #### #### ####'"
                      placeholder="0000 0000 0000 0000"
                      :class="{'is-invalid': submitted && !pagamentoData.cartao}">
                  </b-form-input>
                  <div v-if="submitted && !pagamentoData.cartao" class="invalid-feedback">
                    <span>Número do Cartão obrigatório, favor preencher</span>
                  </div>
                </b-form-group>

                <b-row class="mt-4">
                  <b-col lg="6">
                    <b-form-group
                        id="input-group-2"
                        label="Nome Impresso no Cartão"
                        label-for="input-number"
                        class="mb-0">
                      <b-form-input
                          id="input-number"
                          v-model="pagamentoData.nomecartao"
                          placeholder="Nome Impresso no Cartão"
                          :class="{'is-invalid': submitted && !pagamentoData.nomecartao}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.nomecartao" class="invalid-feedback">
                        <span>Nome obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col lg="3">
                    <b-form-group
                        id="input-group-2"
                        label="Validade do Cartão"
                        label-for="input-date"
                        class="mb-0">
                      <b-form-input
                          id="input-date"
                          v-model="pagamentoData.validade"
                          placeholder="MM/YY"
                          v-maska="'##/##'"
                          :class="{'is-invalid': submitted && !pagamentoData.validade}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.validade" class="invalid-feedback">
                        <span>Validade do Cartão obrigatória, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col lg="3">
                    <b-form-group
                        id="input-group-2"
                        label="Código de Verificação"
                        label-for="cvvcodeInput"
                        class="mb-0">
                      <b-form-input
                          id="cvvcodeInput"
                          v-model="pagamentoData.cvv"
                          placeholder="Entrar com código CVV"
                          v-maska="'###'"
                          :class="{'is-invalid': submitted && !pagamentoData.cvv}">
                      </b-form-input>
                      <div v-if="submitted && !pagamentoData.cvv" class="invalid-feedback">
                        <span>Código de Verificação obrigatório, favor preencher</span>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

              </div>
            </div>
          </div>
        </div>


        <hr>
        <div class="text-end p-3">
          <b-button variant="light" @click="showModalPagamento = false">
            Fechar
          </b-button>

          <b-button class="ms-1" variant="success" @click="confPagamento">
            Confirmar
          </b-button>
        </div>
      </form>
    </b-modal>



    <b-modal  size="lg"
              title="Token para consumo de API" v-model="showModalToken" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <div>
              <div>

                <b-row class="mt-4">
                  <b-col lg="12">
                    <b-form-group
                        id="input-group-1"
                        label="Token"
                        label-for="input-token"
                        class="mb-0">
                      <b-form-input
                          id="input-token"
                          :disabled="true"
                          v-model="usuarioData.api_token"
                          placeholder="Token">
                      </b-form-input>
                    </b-form-group>
                  </b-col>


                </b-row>
              </div>
            </div>

            <hr>
            <div class="text-end p-3">
              <b-button variant="light" @click="showModalToken = false">
                Fechar
              </b-button>

            </div>

          </div>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>
